import { useEffect } from 'react';
import NotificationActions from '../../../../Common/Actions/NotificationActions';
import { loadAuditRecord } from '../../RateAuditPageViewSlice';
import { parseFilterFromQueryString, toExclusiveDate } from '../Business/RatesAuditHelpers';
import { useRatesDispatch } from "../../../Redux/RatesHooks";

export function useLoadRecords(urlLocation: Location, urlDateFormat: string) {
    const dispatch = useRatesDispatch();

    useEffect(() => {
        const interval = parseFilterFromQueryString(urlLocation, urlDateFormat);
        if(!interval.valid || interval.from === null || interval.to === null) {
            return;
        }
        if(interval.from && interval.to) {
            NotificationActions.clearNotifications();
            dispatch(loadAuditRecord({ fromInclusive: interval.from, toExclusive: toExclusiveDate(interval.to) }));
        }
    }, [dispatch, urlDateFormat, urlLocation]);
}
